<template>
    <b-modal v-model="display" title="Código QR" ref="modal" hide-footer>
        <div class="esimQrcodeModal">
            <b-tabs>
                <b-tab title="Código de Android" active>
                    <div class="code-holder">
                        <div class="qr-code-container">
                            <canvas id="canvas-modal-android"></canvas>
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Código de iOS">
                    <div class="code-holder">
                        <div class="qr-code-container">
                            <canvas id="canvas-modal-ios"></canvas>
                        </div>
                        <div class="text-center pb-3">
                            <b-button @click="openIphoneOnline">
                                Activar online
                                <span class="imoon-sim_card"></span>
                            </b-button>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </b-modal>
</template>

<script>
import QRCode from 'qrcode'

export default {
    name: "esimQrcodeModal",
    props: {
        appleSpecific: {
            type: String,
            default: "https://esimsetup.apple.com/esim_qrcode_provisioning?carddata="
        },
        timeoutInterval: {
            type: Number,
            default: 50
        },
        QRCodeOptions: {
            type: Object,
            default: () => {
                return { width: 300 }
            }
        },
    },
    data() {
        return {
            lpnString: 'asd',
            display: false,
            qrCodeAndroid: null,
            qrCodeIos: null
        }
    },
    methods: {
        openIphoneOnline() {
            window.open(this.appleSpecific + this.lpnString, '_blank');
        },
        generateQrCode() {
            QRCode.toCanvas(document.getElementById('canvas-modal-android'), this.lpnString, this.QRCodeOptions, (error) => {
                if (error) console.error(error)
                console.log('success!');
            })
            QRCode.toCanvas(document.getElementById('canvas-modal-ios'), this.lpnString, this.QRCodeOptions, (error) => {
                if (error) console.error(error)
                console.log('success!');
            })
        },
        show(lpnString) {
            this.display = true
            this.lpnString = lpnString
            this.$refs.modal.$on('shown', () => {
                console.log('Modal has been shown');
                this.$nextTick(() => {
                    setTimeout(this.generateQrCode, this.timeoutInterval)
                })
            });
        },
        hide() {
            this.display = false
        }
    }
}
</script>

<style lang="scss">
@import '@/sass/utils/_variables.scss';
$size: 15em;

.esimQrcodeModal {
    .code-holder{
        background-color: $black;
        border-radius: 3px;
        // border: 1px solid $accent;
        margin-top: 1.0em;
        padding: 0.5em;
        .qr-code-container {
            text-align: center;
    
            canvas {
                padding: 1em;
                width: $size !important;
                height: $size !important;
            }
        }
    }
}
</style>